import ScalarIconUpload_vue_vue_type_script_setup_true_lang_default from "./ScalarIconUpload.vue.script.js";
//#region src/components/ScalarIconUpload.vue
var ScalarIconUpload_default = ScalarIconUpload_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconUpload_default as default };

//# sourceMappingURL=ScalarIconUpload.js.map